import { render } from "./CustomCheckbox.vue?vue&type=template&id=297d37f0&ts=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=297d37f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__